import { DEFAULT_GRIND, DEFAULT_WEIGHT, formatMoney, type Product, unitPrice } from '@c214/shared';
import { Link, useNavigate } from 'react-router-dom';
import { useProducts } from '../../hooks/useProducts';
import { useCart, useFavorites } from '../../providers';
import { PackArt } from '../product/PackArt';
import { Button } from '../ui/button';
import { HeartButton } from '../ui/heart-button';

function Row({ product }: { product: Product }) {
  const cart = useCart();
  const favorites = useFavorites();

  return (
    <div className="flex flex-wrap items-center gap-4 border-t border-line py-5">
      <Link to={`/product/${product.id}`} className="shrink-0">
        <PackArt variant="mini" name={product.name} className="h-[90px] w-[72px]" />
      </Link>
      <div className="min-w-40 flex-[2]">
        <Link
          to={`/product/${product.id}`}
          className="text-[clamp(20px,2.6vw,30px)] font-bold tracking-[-0.03em] text-ink no-underline"
        >
          {product.name}
        </Link>
        <p className="mono-label mt-1">
          {product.region} · ОБСМАЖЕНО {product.roastedAt.slice(8)}.{product.roastedAt.slice(5, 7)}
        </p>
      </div>
      <p className="min-w-[120px] flex-[1.4] text-[14px] text-muted">{product.notes}</p>
      <span className="w-[84px] shrink-0 text-[19px] font-bold text-ink">
        {formatMoney(unitPrice(product.price, DEFAULT_WEIGHT))}
      </span>
      <div className="w-10 shrink-0">
        <HeartButton
          active={favorites.has(product.id)}
          onToggle={() => favorites.toggle(product.id)}
        />
      </div>
      <Button
        variant="secondary"
        className="w-[112px] shrink-0 px-3"
        onClick={() =>
          cart.add({
            productId: product.id,
            name: product.name,
            weight: DEFAULT_WEIGHT,
            grind: DEFAULT_GRIND,
            unitPrice: unitPrice(product.price, DEFAULT_WEIGHT),
            qty: 1,
          })
        }
      >
        + У КОШИК
      </Button>
    </div>
  );
}

export function PopularList() {
  const { data: products = [], isError } = useProducts();
  const navigate = useNavigate();

  return (
    <section className="section-pad border-t border-line">
      <div className="mb-8 flex items-center justify-between">
        <h2 className="m-0 text-[clamp(28px,4vw,52px)] font-bold tracking-[-0.04em]">Популярне</h2>
        <button
          type="button"
          onClick={() => navigate('/catalog')}
          className="border-none bg-transparent p-0 text-[14px] font-semibold text-accent cursor-pointer"
        >
          ВЕСЬ КАТАЛОГ →
        </button>
      </div>
      {isError ? (
        <p className="section-pad mono-label">Не вдалося завантажити популярне.</p>
      ) : (
        products.slice(0, 3).map((product) => <Row key={product.id} product={product} />)
      )}
    </section>
  );
}
